<template>
<!-- 支付成功 -->
  <div v-if="bodyShow" class="buying-tickets-succ">
    <!--  -->
    <div class="box">
        <img src="@a/be-myself/2020/success.png" alt="">
        <div class="title">
            购票成功
        </div>
<!--        <div class="text">-->
<!--            <span v-if="fzr.user_name">负责人：{{fzr.user_name}}</span>-->
<!--            <span v-if="fzr.user_phone">联系电话：{{fzr.user_phone}}</span>-->
<!--        </div>-->
    </div>


    <div class="qrcode" v-show="order_info.product_id==326 || order_info.product_id==327 || order_info.product_id==338 || order_info.product_id==339 || order_info.product_id==340 || order_info.product_id==341 || order_info.product_id==342 || order_info.product_id==343 || order_info.product_id==344 || order_info.product_id==345 || order_info.product_id==346 || order_info.product_id==347">
      <div class="title">
        <div class="line"></div>
        <span>添加活动负责人小昭(长按识别下方二维码添加)</span>
      </div>
      <div style="text-align: center;width: 100%;font-weight: bold;font-size:40px;color: #ea5f00;line-height:60px;">
        <img style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode_202601.jpg" alt="">
      </div>
    </div>
    <div class="qrcode" v-show="order_info.product_id==328 || order_info.product_id==329 || order_info.product_id==330 || order_info.product_id==331 || order_info.product_id==333 || order_info.product_id==334 || order_info.product_id==335 || order_info.product_id==336 || order_info.product_id==337">
      <div class="title">
        <div class="line"></div>
        <span>添加活动负责人小美(长按识别下方二维码添加)</span>
      </div>
      <div style="text-align: center;width: 100%;font-weight: bold;font-size:40px;color: #ea5f00;line-height:60px;">
        <img style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode_202603.jpg" alt="">
      </div>
    </div>

    <!-- 订单信息 -->
    <div class="order">
        <div class="title">
            <div class="line"></div>
            <span>订单信息</span>
        </div>
        <div class="content">

            <div class="row">
<!--                <div class="title-child">商品信息：</div>-->
                <div class="text">
                    <div style="line-height:0.6rem;font-weight: bold;">{{order_info.product_name}}</div>
<!--                    <div><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">{{order_info.province+' '+order_info.city+' '+order_info.district}}</div>-->
<!--                    <div><img class="img2" src="@a/be-myself/2020/time.png" alt="">12月30日·{{JSON.parse(order_info.detail||order_info.product_detail)?JSON.parse(order_info.product_detail).createTime:''}}</div>-->
<!--                    <div><img class="img2" src="@a/be-myself/2020/time.png" alt="">12月28日·{{JSON.parse(order_info.product_detail).createTime}}</div>-->

<!--                    <div v-show="order_info.product_id!=242 && order_info.product_id!=243 && order_info.product_id!=244">-->
<!--                      <img class="img2" src="@a/be-myself/2020/time.png" alt="">做自己节：12月28日·{{JSON.parse(order_info.product_detail).createTime}}-->
<!--                    </div>-->


                    <div v-show="order_info.product_id==326 || order_info.product_id==327 || order_info.product_id==328 || order_info.product_id==329 || order_info.product_id==331 || order_info.product_id==333 || order_info.product_id==334 || order_info.product_id==335 || order_info.product_id==336 || order_info.product_id==337 || order_info.product_id==338 || order_info.product_id==339 || order_info.product_id==340 || order_info.product_id==341 || order_info.product_id==342 || order_info.product_id==343 || order_info.product_id==344 || order_info.product_id==345 || order_info.product_id==346 || order_info.product_id==347">
                      <div style="font-weight: bold;line-height:1rem;">做自己节：<span style="color: #ff0000">校验码 <</span> <span style="color: #ff0000;font-weight: bold;font-size:0.7rem;">{{order_info.code}}</span> <span style="color: #ff0000">></span></div>
                      <div><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心一层</div>
                      <div><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月16日·9:00-18:00</div>
                      <div class="list-title"></div>
                      <br>
                    </div>
                  <div v-show="order_info.product_id==329 || order_info.product_id==330">
                    <div style="font-weight: bold;line-height:1rem;">超级个体资源碰撞晚宴：</div>
                    <div><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心宴会厅</div>
                    <div><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月16日·19:00-21:00</div>
                    <div class="list-title"></div>
                    <br>
                  </div>

                  <div v-show="order_info.product_id==328 || order_info.product_id==330 || order_info.product_id==331 || order_info.product_id==333 || order_info.product_id==334 || order_info.product_id==335 || order_info.product_id==336 || order_info.product_id==337">
                    <div style="font-weight: bold;line-height:1rem;">超级个体大课：<span style="color:#00a3ff;">校验码 < <span style="font-weight: bold;font-size:0.7rem;">{{order_info.code2}}</span> ></span></div>
                    <div><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心602国际会议厅BC</div>
                    <div><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月17日-1月18日·9:00-18:00(2天1晚)</div>
                    <div class="list-title"></div>
                    <br>
                  </div>


                </div>
            </div>



<!--            <div class="row">-->
<!--                <div class="title-child">应付金额：</div>-->
<!--                <div class="text">¥{{price}}</div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--                <div class="title-child">实付金额：</div>-->
<!--                <div class="text">¥{{order_info.price/100}}</div>-->
<!--            </div>-->
            <!-- <div class="row">
                <div class="title-child">付款时间：</div>
                <div class="text">2020.10.29 16:24</div>
            </div> -->
        </div>
    </div>
  </div>
</template>

<script>
import { saveInfo,orderGet } from "@/api/be_myself"
import { phoneValidation } from "@u/validation";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            fzr:{},
            order_info:{}
        }
    },
    props:['oid','name','phone','itemObj','price'],
    methods:{
        pullData(){
            if(!this.name || !this.phone || !this.oid || !phoneValidation(this.phone)){
                this.$toast('订单或用户信息不能为空！');
                return
            }
          // this.oid = 10202;

            orderGet({
              id:this.oid
            }).then(data=>{
              if(data.error>0){
                this.$toast(data.detail);
                return
              }
              this.fzr = data.item.product_user_list[0];
              this.order_info = data.item;

            });


            this.bodyShow = true;
            shareCon("beMyself", this);
            
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.buying-tickets-succ{
    padding-top: 4px;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .list-title{
      border: 1px solid #cbcbcb;
    }
    .box{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-color: #ffffff;
        padding: 48px 48px 20px;
        img{
            margin-bottom: 24px;
            width: 84px;
            height: 84px;
        }

        .title{
            font-size: 36px;
            color: #333333;
            font-weight: 600;
            line-height: 50px;
            text-align: center;
            margin-bottom: 40px;
        }
        .text{
            display: flex;
            align-items: center;
            font-size: 28px;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
            span{
                &:first-child{
                    margin-right: 40px;
                }
            }
        }
    }
    .qrcode{
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        padding: 24px 24px;
        background-color: #ffffff;
        .title{
            display: flex;
            align-items: center;
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 44px;
            margin-bottom: 40px;
            .line{
                width: 8px;
                height: 20px;
                border-radius: 4px;
                background-color: #FF9800;
                margin-right: 12px;
            }
            span{
                line-height: 1;
            }
        }
        .q{
            display: block;
            margin: 0 auto;
            width: 140px;
            height: 140px;
            margin-bottom: 15px;
        }
        p{
            font-weight: 400;
            color: #606060;
            line-height: 34px;
            text-align: center;
        }
    }
    .order{
        padding: 24px 24px;
        background-color: #ffffff;
        margin-top: 8px;
        flex: 1;
        .title{
            display: flex;
            align-items: center;
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 44px;
            margin-bottom: 40px;
            .line{
                width: 8px;
                height: 20px;
                border-radius: 4px;
                background-color: #FF9800;
                margin-right: 12px;
            }
            span{
                line-height: 1;
            }
        }
        .content{
            padding: 38px 24px 20px;
            border-top: 1px solid #E4E4E4;
            .row{
                display: flex;
                margin-bottom: 24px;
                .title-child{
                    color: #999999;
                    font-size: 28px;
                    margin-right: 16px;
                    width: 140px;
                    line-height: 40px;
                    display: flex;
                    align-self: flex-start;
                }
                .text{
                    color: #606060;
                    flex: 1;
                    font-size: 28px;
                    div{
                        margin-bottom: 12px;
                        //line-height: 40px;
                        line-height: 0px;
                        .img1{
                            width: 30px;
                            height: 28px;
                            margin-right: 8px;
                        }
                        .img2{
                            width: 27px;
                            height: 27px;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>